import { DataFarmType } from '../dataFarmType';
import { DataTransform } from '../dataTransform';
import { IncludeInfo } from '../includeInfo';
import { FindReplace } from '../rowExtractorTransform';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';

export class ColumnLookupTransform extends DataTransform<ColumnLookupTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.columnLookup,nodeID);
      this.transformConfig = new ColumnLookupTransformConfig();
    }

    static fromJSON(data: any): ColumnLookupTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnLookupTransform = Object.assign(new ColumnLookupTransform(0, 0, '', ''), data);
        instance.transformConfig = ColumnLookupTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class ColumnLookupTransformConfig {
    resetRows:boolean;
    overwriteRows:boolean;
    lookupFarm:string;
    lookupFarmType:number;
    defSourceField: string;
    defTargetField: string;
    sampleStart: number;
    sampleEnd: number;
    runAll = false;
    farm:string;
    farmType: number;
    transformType: TransformType;
    instance: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    rules: ColumnLookupRule[];
    transformerType: string;
    transformerName: string;
    sourceDataFarm:string;
    //sourceDataFarmType:number;

    defKeyField: string;
    defLookupField: string;
    lookupDedup?: number;
    
    static fromJSON(data: any): ColumnLookupTransformConfig {
        const instance: ColumnLookupTransformConfig = Object.assign(new ColumnLookupTransformConfig(), data);

        const rules: ColumnLookupRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = ColumnLookupRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export enum IfErrorType {
    fail = 0,
    null = 1,
    zero = 2
}

export class IfErrorTypeUtil {
    static toString(type: IfErrorType): string {
        switch (type) {
            case IfErrorType.fail:
                return 'Fail';
            case IfErrorType.null:
                return 'NULL';
            case IfErrorType.zero:
                return '0';
        }
    }
}

export class ColumnLookupRule extends TransformRule {
    sourceField: string;
    targetField: string;
    expression: string;
    ifError: number;
    run: boolean;
    targetDataType: string;	
    keyField: string;	
    lookupField: string;	
    conditionStart: ConditionStartType;	
    keyParams: string[] = [];	
    conditionEnd: ConditionEndType;	
    lookupParams: string[] = [];	
    sourceColumn: string;
    targetColumn: string;
    // resultFind: string;	
    // resultReplace: string;	
    ifNoMatch: string;
    findReplace?: FindReplace;
    matchCase: boolean;
    matchAll: boolean;
    
    static fromJSON(data: any): ColumnLookupRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnLookupRule = Object.assign(new ColumnLookupRule(), data);

        return instance;
    }
}

export enum ColumnLookupDataType {
    Integer = 0,
    Float = 1,
    Timestamp = 2,
    Duration = 3,
    String = 4,
}

export enum ConditionStartType {
    Contents = 0,
    LeftChars = 1,
    RightChars = 2,
    Before = 3,
    After = 4,
    Between = 5
}

export enum ConditionEndType {
    Contents = 0,
    LeftChars = 1,
    RightChars = 2,
    Before = 3,
    After = 4,
    Between = 5
}

export enum ColumnLookupRuleType {
    group  = 0,
    contains = 1
}

export class ColumnLookupRuleStats {
    ruleID: number;
    activityCount: number;
    rowCount: number;
}

export class ColumnLookupPreviewStats {
    activityCount: number;
    rowCount: number;
    ruleStats: Array<ColumnLookupRuleStats>;
}

export enum LookupDedup {
    KeepLast = 0,
    KeepFirst = 1,
    NoDedup = 2
}